export const staffListColumns = [
  {
    Header: "Staff Name",
    accessor: "name",
  },
  {
    Header: "Role",
    accessor: "role",
  },
  {
    Header: "Action",
    accessor: "actions",
  },
];
